export default "__VITE_ASSET__CzE3wJIE__"